import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { BaseButton } from '..';
import './RequestDeletionConfirmationModal.scss';

export const RequestDeletionConfirmationModal = (props) => {
  const { t: common } = useTranslation('common');

  return (
    <Modal
      styles={{ body: { maxHeight: '60vh', overflow: 'auto' } }}
      className="search-form"
      closable={true}
      footer={props.footer}
      onCancel={props.onCancel}
      title={props.title}
      open={props.visible}
      width={680}
    >
      <div className="request-deletion-confirmation-modal__content">
        <div className="request-deletion-confirmation-modal__text">
          <p className="copy copy--color-dark">{common('request.requestDeletion.confirmationInfo')}</p>
        </div>
        <BaseButton
          onClick={props.onConfirm}
          className="multiline-button"
          data-testid="details-delete-registration-button"
          fill={true}
        >
          {common('request.requestDeletion.continue')}
        </BaseButton>
      </div>
    </Modal>
  );
};

export default RequestDeletionConfirmationModal;
